// extracted by mini-css-extract-plugin
export default {"form":"form_form__ovL2P","input":"form_input__PWpWI","icon":"form_icon__uuV1B","btn":"form_btn__w-J0w"};